export enum LotType {
    COMPETITIVE = 'COMPETITIVE',
    SEALED = 'SEALED',
    BUYITNOW = 'BUYITNOW',
    VIEWONLY = 'VIEWONLY',
    PARENT = 'PARENT',
}
